import { prompt, type PromptDefinition } from './models';

export const OPERATIONS_MANAGER_PROMPTS = [
    prompt(
        'Understand it',
        'What operational disruptions are recorded for this building?',
        'Which buildings have recurring operational disruptions requiring intervention?'
    ),
    prompt(
        'Coordinate people',
        'Who owns the open operational actions for this building?',
        'Which buildings have operational actions without an assigned owner?'
    ),
    prompt(
        'Manage risk',
        "What do this building's records say about business continuity arrangements?",
        'Which buildings lack current business continuity documentation?'
    ),
    prompt(
        'Keep it running',
        'Find operating procedures for this building covering…',
        'Find operating procedures across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Understand it',
        'Which service commitments for this building lack evidence of delivery?',
        'Which buildings have documented gaps in operational service delivery?'
    ),
    prompt(
        'Understand it',
        'What recurring incidents affect daily operation of this building?',
        'Compare recurring operational incidents across my buildings.'
    ),
    prompt(
        'Coordinate people',
        "What escalation paths are documented for this building's service failures?",
        'Which buildings have missing or unclear operational escalation paths?'
    ),
    prompt(
        'Keep it running',
        'Find operational incident records for this building involving…',
        'Find operational incident records across my buildings involving…',
        'prefill'
    ),
    prompt(
        'Understand it',
        'What dependencies could interrupt operations in this building, according to the records?',
        'Which buildings have documented operational dependencies needing contingency review?'
    ),
    prompt(
        'Understand it',
        'What changes to operating procedures are recorded for this building?',
        'Compare recent operating-procedure changes across my buildings.'
    ),
    prompt(
        'Understand it',
        'Which operational handover items remain open for this building?',
        'Which buildings have unresolved operational handover items?'
    ),
    prompt(
        'Keep it running',
        'Prepare an operations briefing for this building about…',
        'Prepare a cross-building operations briefing about…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
